export default "__VITE_ASSET__5e8f5201__"